var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
import { useEffect, useState } from 'react';
import { Container, RightContent } from 'app/components/LeftNav';
import { useParams } from 'react-router-dom';
import resources from 'app/store/resources';
import { setProject } from 'app/store/actions/project';
import Loader from 'app/components/Loader/Loader.jsx';
import { NotFound } from 'app/components/NotFound/NotFound';
import pipe from 'app/core/utils/pipe';
import { Nav } from './Nav.jsx';
import { projectSelector } from 'app/store/selectors/project';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllDashboards } from 'app/store/reducers/dashboards';
import { dashboardsSelector } from 'app/store/selectors/dashboards';
import { permission } from 'app/containers/Permissions/index.js';
const Project = ({ setProject, children }) => {
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const project = useSelector(projectSelector);
    const dashboards = useSelector(dashboardsSelector);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const promises = [
                    resources.assets.fetchOne(projectId),
                    permission(['projet_dashboards__read']) && dispatch(fetchAllDashboards()),
                ];
                const [res] = yield Promise.all(promises);
                setProject(res.resources[0]);
            }
            catch (err) {
                throw new Error(err);
            }
            setIsLoading(false);
        }))();
        return () => {
            setIsLoading(true);
        };
    }, [projectId]);
    if (isLoading)
        return _jsx(Loader, {});
    if (!(project === null || project === void 0 ? void 0 : project.id))
        return _jsx(NotFound, {});
    return (_jsxs(Container, { children: [_jsx(Nav, { project: project, dashboards: dashboards }), _jsx(RightContent, { children: children })] }));
};
const Component = pipe().withRouter().connect(undefined, { setProject }).render(Project);
export default Component;
